<div *ngIf="!this.loading && !this.favourites.length" style="background-color: #F5F7F8; height: 100vh; width: 100vw; display: flex; justify-content: center; align-items: center;">
  <div style="text-align: center; padding: 10px;">
    <img style="z-index: 1000; width: 22px; height: 22px; position: absolute; top: 25px; left: 20px;" (click)="this.back()" src="/assets/images/shared/back.svg">
    <h2 style="width: 100%; height: 22px; position: absolute; top: 20px; left: 0px; margin: auto; text-align: center;">{{ 'Любими (' + this.favourites.length + ')' }}</h2>
    <img src="/assets/images/favourites/empty-favs.svg" alt="" style="height: 226px; width: 226px; margin-bottom: 10px;">
    <br>
    <p style="font-size: 16px; font-weight: bold; margin-top: 7px;">Списъкът с любими е празен</p>
    <p style="margin-top: 7px; color: #ADAFBB;">Разгледай категориите и запази любимите си продукти на едно място</p>
    <button (click)="this.goToCategories()" type="button" class="btn btn-primary" style="width: 60%; margin: auto;">Виж продуктите</button>
  </div>
</div>

<div *ngIf="!this.loading && this.favourites.length" style="background-color: #F5F7F8; height: 100vh; width: 100vw; overflow: hidden;">
  <div style="padding: 10px; overflow: hidden;">
    <div style="height: 10vh;">
      <img style="width: 22px; height: 22px; position: absolute; top: 20px; left: 20px;" (click)="this.back()" src="/assets/images/shared/back.svg">
      <h2 style="text-align: center;">{{ 'Любими (' + this.favourites.length + ')' }}</h2>
    </div>

    <div style="height: 90vh; overflow-y: scroll;">
      <div class="row">
        <div class="col-12" *ngFor="let item of this.favourites">
          <div
            [matBadge]="item.is_in_group ? 'Групова поръчка' : ''"
            matBadgeColor="warn"
            matBadgePosition="before"
            (click)="this.openItem(item.uuid, 'none')"
            class="card mb-3"
            style="border: unset; max-width: 540px; padding: 10px; background-color: white; border-radius: 9px;"
          >
            <div class="row">
              <div class="col-4">
                <img [src]="item.imageSrc" class="card-img img-fluid" style="height: 120px;" alt="...">
              </div>

              <div class="col-8" style="padding: 0px; padding-right: 5px;">
                <p style="margin-bottom: 5px; display: -webkit-box; -webkit-line-clamp: 3; line-clamp: 3; -webkit-box-orient: vertical; height: 65px; overflow: hidden; text-overflow: ellipsis; margin-top: 5px;">
                  {{ item?.name || '' }}
                </p>

                <img
                  src="/assets/images/favourites/remove-from-fav.svg"
                  (click)="this.removeFromFavourites(item.uuid, $event)"
                  style="z-index: 1000000; margin-right: 20px; float: right; width: 22px; height: 22px;"
                  alt="..."
                >

                <ngb-rating style="position: relative;" [readonly]="true" [max]="5" [(rate)]="item.ratingAvgValue!">
                  <ng-template let-fill="fill" let-index="index">
                    <i class="bi-star{{fill === 100 ? '-fill filled-rating' : ''}} rating" [class.filled]="fill === 100" [class.low]="index < 3"></i>
                  </ng-template>
                </ngb-rating>
                <span style="color: #b0c4de; font-size: 10px;">&nbsp; {{ ' (' + (item.ratings?.data?.length || 0) + ')' }}</span>

                <div *ngIf="hasProductPrice(item)" style="font-weight: 700; margin-top: 5px;">
                  <app-price
                    class="wishlist-card-price"
                    [amount]="getProductCardBasePrice(item)"
                    layout="inline"
                  ></app-price>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
